import * as React from "react";

const VestigeIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
		<path d="M114.89 297.94c-3.64-20.95-21.08-42.26-13.99-62.48 36.57-73.05 73.14-146.11 109.45-219.29 3.27-6.58 7.02-7.08 14.63-9.22 1.86-.52 64.8-9.02 51.06 10.3-55.08 92.42-102.95 191.41-161.16 280.69ZM74.46 170.4C60.93 127.9 40.39 70.36 26.06 31.1c0 0-12.25-22.51 5.82-24.07C92.75 1.81 81.33-9.89 99.39 40.95c19.53 54.96-7 85.2-24.93 129.44Z" />
	</svg>
);

export default VestigeIcon;
